/* eslint-disable @typescript-eslint/no-unused-vars */
import React, {useEffect, useState} from 'react';
import {CaretRightOutlined} from "@ant-design/icons";
import PageTitle from "../../components/common/PageTitle/PageTitle";
import styles from './SystemBatchRunPage.module.scss';
import LeftListItem from "./LeftListItem/LeftListItem";
import {JobConfigsInterface, JobHistoryInterface} from "./SystemBatchRun.interface";
import RightList from "./RightList/RightList";
import {useMessageStore} from "../../stores/messageStore";
import batchAPI from "../../api/batchAPI";
import constants from "../../constants";

const SystemBatchRun = () => {
	const [leftList, setLeftList] = useState<JobConfigsInterface[]>([])
	const [rightList, setRightList] = useState<JobHistoryInterface[]>([]);
	const [selectedLeftItem, setSelectedLeftItem] = useState<JobConfigsInterface | undefined>(undefined);
	const [currentPage, setCurrentPage] = useState<number>(1);

	const getRightData = async (page: number, queueName: string) => {
		return await batchAPI.fetchJobHistoryRequestAPI({
			page,
			queueName,
			limit: constants.PAGE_SIZE,
		});
	}

	const onClickBtn = async (queueName: string) => {
		const res = await batchAPI.runBatchJobRequestAPI(queueName);
		useMessageStore.setState({
			isShow: true,
			type: 'success',
			content: res.message,
		});
		await new Promise((resolve) => setTimeout(resolve, 1000));
		const newData = await getRightData(currentPage, queueName);
		setRightList(newData);
	};

	const onClickListItem = (item: JobConfigsInterface) => {
		// 현재 선택된 아이템을 또 선택하면 그냥 리턴
		if (item.queueName === selectedLeftItem?.queueName) {
			return;
		}

		setSelectedLeftItem(item);
		setCurrentPage(1);
	};

	const changeCurrentPage = (value: number) => {
		const nextPage = Math.max(currentPage + value, 1);
		setCurrentPage(nextPage);
	}

	// 왼쪽 목록 가져오기
	useEffect(() => {
		batchAPI.fetchJobConfigsRequestAPI()
			.then((res) => {
				setLeftList(res);
				setSelectedLeftItem(res[0]);
			});
		return () => {
			setLeftList([]);
		}
	}, []);

	// 왼쪽 목록에서 선택한 항목에 대해 오른쪽 목록 가져오기
	useEffect(() => {
		if (selectedLeftItem) {
			getRightData(currentPage, selectedLeftItem.queueName)
				.then((res) => setRightList(res));
		}
		return () => setRightList([]);
	}, [currentPage, selectedLeftItem]);

	return (
		<div className={styles.outerWrap}>
			<PageTitle title="배치 실행"/>
			<div
				className={styles.runButtonWrap}
			>
				<p>{selectedLeftItem?.queueName} 실행</p>
				<CaretRightOutlined
					className={styles.runButton}
					onClick={() => selectedLeftItem && onClickBtn(selectedLeftItem.queueName)}
				/>
			</div>

			<div className={styles.innerWrap}>
				{/* 왼쪽 리스트 */}
				<div className={styles.leftWrap}>
					{leftList.map((item, index) => (
						<LeftListItem
							key={item.queueName}
							onClick={onClickListItem}
							selected={selectedLeftItem?.queueName === item.queueName}
							data={item}
						/>
					))}
				</div>

				{/* 오른쪽 화면 */}
				<div className={styles.rightWrap}>
					<RightList
						data={rightList}
						currentPage={currentPage}
						changeCurrentPage={changeCurrentPage}
					/>
				</div>
			</div>
		</div>
	);
};

export default SystemBatchRun;
